import axios from 'axios';
import qoalaStorage from '~/core/Storage';

export default {
  async registerUser(state, datas) {
    try {
      const { data } = await this.$axios.post('/registrations', datas);
      return data;
    } catch (error) {
      throw error;
    }
  },
  async userRating(state, { ratesSend, callbackSuccess }) {
    try {
      await this.$axios.post('/rates', ratesSend);
      callbackSuccess('', 'Terimakasih atas penilaian dan saran anda.');
    } catch (error) {
      console.log(error);
    }
  },
  async activateUser(context, datas) {
    const { data } = await this.$axios.put('/registrations/check-token', {
      phoneNumber: datas.phoneNumber,
      token: datas.token
    });
    const response = data.data;
    this.$analytics.pushEvent({
      event: 'Register',
      eventAction: 'Flow',
      eventLabel: 'Register-Success'
    });
    return response;
  },
  async resendActivationReg(context, datas) {
    try {
      await this.$axios.post('/registrations/resend-otp-token', datas);
      return true;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = errorResponse.data;
      return errorData;
    }
  },
  async getProfile(context, { callback, callbackFail }) {
    try {
      const { data } = await this.$axios.get('/users/profile');
      const response = data.data;
      context.commit('updateDataUser', response);
      callback();
    } catch (error) {
      const errorResponse = error.response;
      // Handling when error response is undefined
      let errorMessage;
      if (errorResponse) {
        errorMessage = errorResponse.data ? errorResponse.data.message : '';
      }
      // When I find 'user/getProfile', callbackFail is not available
      if (callbackFail) {
        callbackFail(errorMessage || '');
      }
    }
  },
  async requestLoginOtp(context, phone) {
    try {
      const { data } = await this.$axios.post('/sessions/request-login-otp', {
        phoneNumber: phone
      });
      return data.data;
    } catch (err) {
      console.log(err);
    }
  },
  async validatePhone(context, credentials) {
    try {
      const data = await this.$axios.post('/sessions', credentials);
      throw data.response.data;
    } catch (error) {
      return error;
    }
  },
  async login(context, credentials) {
    try {
      const { data } = await this.$axios.post('/sessions', credentials);
      const response = data.data;
      context.commit('updateData', response);
      this.$axios.setToken(response.token, 'Bearer');
      context.dispatch('intervalToken', {
        refresh: response.refresh
      });
      this.$gtm.push({
        event: 'setUserId',
        userId: response.user.id
      });
      this.$analytics.pushEvent(
        {
          event: 'Login-Page',
          eventCategory: 'User',
          eventAction: 'Login',
          eventLabel: response.user.fullName + ' ' + response.user.email
        },
        {
          event: 'Login-Page',
          eventCategory: 'Login',
          eventAction: 'Login-Page',
          eventLabel: response.user.fullName + ' ' + response.user.email
        }
      );
      window.errorHandler.setUser(response.user.email);
      window.initChat(response.user);
      if (window.isAndroid) {
        // eslint-disable-next-line
        console.log(qoala, response);
        // eslint-disable-next-line
        qoala.tagUser(response.user.email);
      } else if (window.isApple) {
        window.setupWebViewJavascriptBridge(bridge => {
          bridge.callHandler(
            'appleTagUser',
            {
              email: response.user.email
            },
            responseData => {
              console.log('JS appleTagUser response', responseData);
            }
          );
          bridge.callHandler(
            'appleInitFreshchat',
            {
              externalId: response.user.email,
              restoreId: response.user.chattingId
            },
            responseData => {
              console.log('JS appleInitFreshchat response', responseData);
            }
          );
        });
      } else {
        const OneSignal = window.$OneSignal || [];
        OneSignal.push(() => {
          OneSignal.sendTag('email', response.user.email, tagsSent => {
            console.log(tagsSent);
          });
        });
      }
      return response;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = errorResponse.data;
      return errorData;
    }
  },
  async refreshToken(context, { credentials, callback }) {
    try {
      const { data } = await this.$axios.post('/sessions/refresh', credentials, {
        progress: false
      });
      const response = data.data;
      this.$axios.setToken(response.token, 'Bearer');
      context.commit('updateData', response);
      const refresh = context.getters['getUserTokenRefresh'];
      if (refresh) context.commit('clearRefreshToken');
      callback();
      context.dispatch('intervalToken', {
        refresh: response.refresh
      });
    } catch (error) {
      if (error.response) context.dispatch('logout');
    }
  },
  intervalToken(context, dataRefresh) {
    const TIMEOUT = 1000 * 3600 * 48;
    context.commit(
      'updateRefreshToken',
      setTimeout(() => {
        context.dispatch('refreshToken', {
          credentials: dataRefresh,
          callback: () => {}
        });
      }, TIMEOUT)
    );
  },
  async updateUser(context, datas) {
    const refresh = context.getters['getUserTokenRefresh'];
    let noRefresh = false;
    if (datas.noRefresh === true) {
      noRefresh = true;
      delete datas.noRefresh;
    }
    try {
      const { data } = await this.$axios.put('/users/update', datas);
      const response = data.data;
      if (noRefresh === false) {
        await context.dispatch('refreshToken', {
          credentials: {
            refresh
          },
          callback: () => {}
        });
      }

      context.commit('updateDataUser', response);
      return response;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = errorResponse ? errorResponse.data : {};
      throw errorData;
    }
  },
  async requestOTP(state, datas) {
    const { data } = await this.$axios.post('/registrations/reset-security-code', datas);
    const response = data.data;
    return response;
  },
  async verifyData(context, datas) {
    const { data } = await this.$axios.post('/verifications', datas);
    const response = data.data;
    return response;
  },
  async checkOTPStatus(state, datas) {
    const { data } = await this.$axios.post('/registrations/check-security-otp-code', datas);
    const response = data.data;
    return response;
  },
  async verifyOTP(state, datas) {
    const { data } = await this.$axios.post('/verifications/check-token', datas);
    const response = data.data;
    this.$analytics.pushEvent({
      event: 'Account-Login',
      eventLabel: 'Account-Page-Login-Email-Verified'
    });
    return response;
  },
  async resetPassword(state, datas) {
    const data = await this.$axios.post('/registrations/confirm-new-security-code', datas);
    const response = data.data;
    return response;
  },
  async getNotifications(context, { page, callback }) {
    try {
      const { data } = await this.$axios.get(`/notifications?limit=12&&page=${page}&descending=true`);
      const response = data.data;
      const respWithMeta = data;
      context.commit('updateNotificationsList', response);
      callback(respWithMeta);
    } catch (error) {
      const errorResponse = error.response;
      const errorData = errorResponse ? errorResponse.data : null;
      return errorData;
    }
  },
  async getUnreadNotifications(context, { callback, callbackFail }) {
    try {
      const { data } = await this.$axios.get('/notifications/unread');
      const response = data.data;
      callback(response);
    } catch (error) {
      const errorResponse = error.response;
      const errorData = errorResponse.data;
      callbackFail(errorData.message);
    }
  },
  async readNotification(context, notifId) {
    try {
      const { data } = await this.$axios.put(`/notifications/${notifId}`, {
        read: true
      });
      const response = data.data;
      context.commit('updateNotifications', response);
      return response;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = errorResponse.data;
      return errorData;
    }
  },
  async searchAccountBank(context, datas) {
    try {
      const { data } = await axios.post('https://api.qoala.app/api/kyc/bank-inquiry', datas);
      const response = data.data;
      return response;
    } catch (err) {
      return err;
    }
  },
  logout(context) {
    if (window.isAndroid) {
      // eslint-disable-next-line
      qoala.untagUser();
    } else {
      const OneSignal = window.$OneSignal || [];
      OneSignal.push(() => {
        OneSignal.sendTag('email', '', tagsSent => {
          console.log(tagsSent);
        });
      });
    }
    if (window.fcWidget) {
      window.fcWidget.destroy();
    }
    this.$axios.setToken(false);
    qoalaStorage.clear();
    context.commit('clearState');
    context.commit('removeToken');
    context.commit('clearRefreshToken');
    this.$gtm.push({
      event: 'setUserId',
      userId: 'Guest'
    });
  },
  async checkKTP(context, ktp) {
    try {
      const { data } = await axios.post(`${process.env.API_BASE_URL}/kyc/check-ktp`, ktp);
      const response = data.data;
      return response;
    } catch (err) {
      return err;
    }
  },
  async getDocument(context, fileName) {
    try {
      const baseUrl = `${process.env.API_BASE_URL}/`;
      const urlReplace = baseUrl.replace('/api/', '/v1/');
      const dataBase64 = await this.$axios.get(`${urlReplace}documents/${fileName}`);
      return dataBase64.data;
    } catch (err) {
      return err;
    }
  }
};
